module.exports = __webpack_public_path__ + "img/10.28677aa2.gif";